import { createFileRoute } from '@tanstack/react-router';

import { MhsDocumentPage } from '@/pages/blood-report/documents/mhs';

export const Route = createFileRoute('/blood-report/_role-guard/$id/documents/mhs/$studyId')({
  component: MhsDocumentPage,
});
